var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDescargar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10817",
    "data-name": "Group 10817",
    transform: "translate(-370.252 -319.273)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9278",
    "data-name": "Rectangle 9278",
    width: 42,
    height: 42,
    rx: 21,
    transform: "translate(370.252 319.273)",
    fill: "#e9edef",
    opacity: 0.553
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10834",
    "data-name": "Group 10834",
    transform: "translate(384.133 333.145)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10821",
    "data-name": "Group 10821"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23825",
    "data-name": "Path 23825",
    d: "M116.692,6.555a.569.569,0,0,0-.806-.011l-1.65,1.65V.57a.57.57,0,1,0-1.141,0V8.2l-1.668-1.668a.57.57,0,0,0-.806.806l2.623,2.623a.572.572,0,0,0,.4.168h.014a.572.572,0,0,0,.4-.168l2.623-2.623a.56.56,0,0,0,0-.788",
    transform: "translate(-106.524)",
    fill: "#7c8891",
    stroke: "#7c8891",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23826",
    "data-name": "Path 23826",
    d: "M11.035,262.676H3.208A3.213,3.213,0,0,1,0,259.468v-1.3a.57.57,0,0,1,1.141,0v1.3a2.069,2.069,0,0,0,2.067,2.067h7.824a2.069,2.069,0,0,0,2.067-2.067v-1.3a.57.57,0,0,1,1.141,0v1.3a3.207,3.207,0,0,1-3.2,3.208",
    transform: "translate(0 -248.418)",
    fill: "#7c8891",
    stroke: "#7c8891",
    strokeWidth: 1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescargar);
export default __webpack_public_path__ + "static/media/descargar.97cef2abb9ec0e0f6ebdc230f529e822.svg";
export { ForwardRef as ReactComponent };